import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'antd';
import styles from './EditorContainer.scss';

import { getNoteContent } from '../../actions/NoteContentAction';

import EditorWrapper from '../../components/EditorWrapper/EditorWrapper';

@connect(
  state => ({}),
  dispatch => ({
    getNoteContent: (noteId, isForce = false) => dispatch(getNoteContent(noteId, isForce)),
  }),
)
export default class EditorContainer extends Component {
  componentWillReceiveProps(nextProps) {
    this.getNoteContent(nextProps);
  }

  getNoteContent = (props) => {
    const { noteId: nextId } = props.match.params;
    const { noteId: prevId } = this.props.match.params;

    if ((nextId && nextId !== prevId)) {
      props.getNoteContent(nextId);
      return nextId;
    }
    return false;
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <Col
        span={16}
        className={styles['editor-container']}
      >
        <EditorWrapper/>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/EditorContainer/EditorContainer.js